import ReopenVqqMenuItem from "./ReopenVqqMenuItem";
import ReopenVqqConfirmModal from "./ReopenVqqConfirmModal";
import ReopenVqqStatusButton from "./ReopenVqqStatusButton";
import { toReopenConfirmModalProps } from "../../utils/reopenVqqUi";

export function ReopenVqqMenuItemSlot({ flow }) {
  if (!flow?.canReopen) return null;
  return <ReopenVqqMenuItem onOpen={flow.openConfirm} />;
}

export function ReopenVqqStatusButtonSlot({ flow }) {
  return (
    <ReopenVqqStatusButton
      visible={Boolean(flow?.canReopen)}
      onClick={flow?.openConfirm}
    />
  );
}

export function ReopenVqqConfirmModalSlot({ flow, vendorName }) {
  return <ReopenVqqConfirmModal {...toReopenConfirmModalProps(flow, vendorName)} />;
}
